// extracted by mini-css-extract-plugin
export var truncate = "_10-0";